/* ----------------------------------------------------------
   Pill nav — desktop dropdown + L2 flyout
---------------------------------------------------------- */
(function () {
  var CLOSE_DELAY = 140;
  var activeItem = null;
  var dropwrap = null;
  var closeTimer = null;

  function cancelClose() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = setTimeout(close, CLOSE_DELAY);
  }

  function close() {
    closeTimer = null;
    if (dropwrap) { dropwrap.remove(); dropwrap = null; }
    if (activeItem) {
      var link = activeItem.querySelector('.mino-pill__nav-link');
      if (link) link.classList.remove('is-open');
      activeItem = null;
    }
  }

  function open(li) {
    close();
    var tpl = li.querySelector('.mino-pill__drop-tpl');
    if (!tpl) return;

    activeItem = li;
    var link = li.querySelector('.mino-pill__nav-link');
    if (link) link.classList.add('is-open');

    dropwrap = document.createElement('div');
    dropwrap.className = 'mino-pill__dropwrap';

    var panel = document.createElement('div');
    panel.className = 'mino-pill__panel';

    var fragment = tpl.content.cloneNode(true);
    // Collect top-level subitems before moving them into panel
    var subitems = Array.from(fragment.querySelectorAll('.mino-pill__subitem'));

    subitems.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        panel.querySelectorAll('.mino-pill__l2').forEach(function (n) { n.remove(); });
        panel.querySelectorAll('.mino-pill__subitem.is-active').forEach(function (n) { n.classList.remove('is-active'); });

        if (!btn.dataset.hasL2) return;
        btn.classList.add('is-active');

        var l2Tpl = btn.querySelector('.mino-pill__l2-tpl');
        if (!l2Tpl) return;

        var l2 = document.createElement('div');
        l2.className = 'mino-pill__l2';
        l2.style.top = btn.offsetTop + 'px';

        var l2Fragment = l2Tpl.content.cloneNode(true);
        Array.from(l2Fragment.querySelectorAll('.mino-pill__subitem')).forEach(function (r) {
          r.addEventListener('click', function () { window.location.href = r.dataset.url; });
        });
        l2.appendChild(l2Fragment);
        panel.appendChild(l2);
      });

      btn.addEventListener('click', function () {
        window.location.href = btn.dataset.url;
      });
    });

    panel.appendChild(fragment);
    dropwrap.appendChild(panel);
    document.body.appendChild(dropwrap);

    // Position fixed below the trigger link
    var rect = link.getBoundingClientRect();
    var panelW = panel.getBoundingClientRect().width;
    dropwrap.style.left = Math.max(8, rect.left + rect.width / 2 - panelW / 2) + 'px';
    dropwrap.style.top = (rect.bottom + 10) + 'px';
  }

  var navItems = document.querySelectorAll('.mino-pill__nav-item');
  if (!navItems.length) return;

  navItems.forEach(function (li) {
    li.addEventListener('mouseenter', function () {
      cancelClose();
      if (!li.classList.contains('mino-pill__nav-item--has-drop')) {
        if (activeItem) scheduleClose();
        return;
      }
      if (activeItem === li) return;
      open(li);
    });
  });

  // pointermove never fires during a scroll gesture, so CSS-transition-induced
  // synthetic mouse events from scrolling cannot trigger a spurious close.
  document.addEventListener('pointermove', function (e) {
    if (!activeItem) return;
    if (
      e.target.closest('.mino-pill__dropwrap') ||
      e.target.closest('.mino-pill__nav-item--has-drop')
    ) {
      cancelClose();
    } else {
      scheduleClose();
    }
  });

  document.addEventListener('click', function (e) {
    if (!activeItem) return;
    if (e.target.closest('.mino-pill__nav-item') || e.target.closest('.mino-pill__dropwrap')) return;
    close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.addEventListener('resize', close);
})();

/* ----------------------------------------------------------
   Scroll state
---------------------------------------------------------- */
(function () {
  var SCROLL_THRESHOLD = 80;
  var header = document.getElementById('pageheader');
  if (!header) return;

  function updateState() {
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.classList.add('mino-scrolled');
    } else {
      header.classList.remove('mino-scrolled');
    }
  }

  function updateAnnouncementOffset() {
    var bar = document.querySelector('.section-announcement-bar');
    var height = bar ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
  }

  window.addEventListener('scroll', updateState, { passive: true });
  window.addEventListener('resize', updateAnnouncementOffset, { passive: true });
  updateState();
  updateAnnouncementOffset();
})();
